import NiceSelect from "nice-select2";

document.addEventListener("DOMContentLoaded", () => {
    initBreadcrumbsScroll();
    loadTireData();
    initCheckboxRadioToggle();
    initFiltersToggle();
    initVendorCollapse();

    // Zainicjuj NiceSelect dla sortProducts
    const sortSelect = document.getElementById('sortProducts');
    initNiceSelectForElements([sortSelect], {
        searchable: false
    });

    // Inicjalizacja aktywnych elementów na podstawie parametrów URL
    initActiveSeasonCheckboxes();
    initActiveVehicleRadio();
});

// Funkcja dodająca klasę "is-active" do checkboxów na podstawie parametrów URL
const initActiveSeasonCheckboxes = () => {
    const params = getURLParams(); // Pobieramy parametry URL

    // Sprawdzamy, które sezony są obecne w URL
    const activeSeasons = params.sezon || []; // Pobierz parametry sezonów z URL

    // Elementy checkboxów dla sezonów
    const summerCheckbox = document.getElementById('seasonSummer');
    const winterCheckbox = document.getElementById('seasonWinter');
    const allSeasonCheckbox = document.getElementById('seasonAll');

    // Funkcja dodająca klasę 'is-active' do rodzica checkboxa
    const toggleActiveClass = (checkbox, isActive) => {
        const parentItem = checkbox.closest('.group__item');
        if (isActive) {
            parentItem.classList.add('is-active');
        } else {
            parentItem.classList.remove('is-active');
        }
    };

    // Ustawianie klasy `is-active` na podstawie parametrów URL
    toggleActiveClass(summerCheckbox, activeSeasons.includes('letnie'));
    toggleActiveClass(winterCheckbox, activeSeasons.includes('zimowe'));
    toggleActiveClass(allSeasonCheckbox, activeSeasons.includes('caloroczne'));
};

// Funkcja dodająca obsługę typu pojazdu
const initActiveVehicleRadio = () => {
    const params = getURLParams(); // Pobieramy parametry URL

    // Sprawdzamy, jaki typ pojazdu jest obecny w URL
    const activeVehicle = params.pojazd || ''; // Pobierz parametr pojazdu z URL

    // Elementy radio dla typu pojazdu
    const anyVehicleRadio = document.getElementById('vehicleAny');
    const passengerVehicleRadio = document.getElementById('vehiclePassengerSUV');
    const commercialVehicleRadio = document.getElementById('vehicleCommercial');
    const runFlatVehicleRadio = document.getElementById('vehicleRunFlat');

    // Funkcja dodająca klasę 'is-active' do rodzica radio
    const toggleActiveClass = (radio, isActive) => {
        const parentItem = radio.closest('.group__item');
        if (isActive) {
            parentItem.classList.add('is-active');
        } else {
            parentItem.classList.remove('is-active');
        }
    };

    // Ustawianie klasy `is-active` na podstawie parametrów URL
    toggleActiveClass(anyVehicleRadio, activeVehicle === '');
    toggleActiveClass(passengerVehicleRadio, activeVehicle === 'osobowy');
    toggleActiveClass(commercialVehicleRadio, activeVehicle === 'dostawczy');
    toggleActiveClass(runFlatVehicleRadio, activeVehicle === 'run-flat');
};

// Funkcja do pobierania parametrów URL
const getURLParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
        rozmiar1: params.get('rozmiar1') || '', // Pobierz wartość rozmiaru 1 z URL
        rozmiar2: params.get('rozmiar2') || '', // Pobierz wartość rozmiaru 2 z URL
        rozmiar3: params.get('rozmiar3') || '', // Pobierz wartość rozmiaru 3 z URL
        marka: params.get('marka') || '', // Pobierz markę z URL
        klasa: params.get('klasa') || '', // Pobierz klasę z URL
        li: params.get('li') || '', // Pobierz indeks nośności z URL
        si: params.get('si') || '', // Pobierz indeks prędkości z URL
        dot: params.get('dot') || '', // Pobierz wartość DOT z URL
        sezon: params.getAll('sezon[]') || [], // Pobierz wszystkie wartości sezonu (możliwe wielokrotne) z URL
        pojazd: params.get('pojazd') || '' // Pobierz wszystkie wartości pojazdu (możliwe wielokrotne) z URL
    };
};

// Inicjalizacja scrolla breadcrumb (automatyczne przewinięcie do końca)
const initBreadcrumbsScroll = () => {
    const breadcrumbs = document.querySelector('.breadcrumbs');
    if (breadcrumbs) breadcrumbs.scrollLeft = breadcrumbs.scrollWidth;
};

// Funkcja do zniszczenia istniejącej instancji NiceSelect (jeśli istnieje)
const destroyNiceSelect = (selectElement) => {
    const existingNiceSelect = selectElement.nextElementSibling;
    if (existingNiceSelect && existingNiceSelect.classList.contains('nice-select')) {
        existingNiceSelect.remove(); // Usuwa strukturę wygenerowaną przez NiceSelect
        selectElement.classList.remove('nice-select'); // Usuwa klasę `nice-select` z elementu select
    }
};

// Funkcja inicjująca NiceSelect dla podanych elementów
const initNiceSelectForElements = (elements) => {
    const options = {
        searchable: true, // Możliwość wyszukiwania
        placeholder: 'Wybierz', // Placeholder domyślny
        searchtext: 'Szukaj', // Tekst dla pola wyszukiwania
        selectedtext: ' wybrano' // Tekst po wybraniu opcji,

    };

    elements.forEach(select => {
        if (select) {
            destroyNiceSelect(select); // Zniszcz istniejącą instancję NiceSelect
            new NiceSelect(select, options); // Utwórz nową instancję NiceSelect z opcjami
        }
    });
};

// Funkcja do aktualizacji opcji selecta i ustawienia wybranej wartości
const updateSelectOptions = (selectElement, options, selectedValue = '', description = false) => {
    if (options && options.length) {
        selectElement.innerHTML = '<option value="">Wybierz</option>'; // Dodanie placeholdera
        options.forEach(option => {
            const optionElement = document.createElement('option');
            optionElement.value = option.id || option.value;
            optionElement.textContent = description
                ? `${option.value} (${option.description})` // Jeśli dostępne, dodaj opis opcji
                : option.width || option.value;

            // Sprawdź, czy opcja powinna być zaznaczona na podstawie wartości
            if (optionElement.value === selectedValue) optionElement.selected = true;
            selectElement.appendChild(optionElement);
        });
    }
};

// Funkcja do ustawienia klasy "selected" dla odpowiedniej opcji NiceSelect na podstawie wartości z URL
const setSelectedOptionInNiceSelect = (selectElement, selectedValue) => {
    const niceSelect = selectElement.nextElementSibling; // Pobieramy wygenerowaną strukturę NiceSelect
    const options = niceSelect ? niceSelect.querySelectorAll('li') : null;
    let currentText = 'Wybierz'; // Domyślny tekst

    if (options) {
        options.forEach(option => {
            // Sprawdzamy, czy wartość 'li' odpowiada wartości parametru z URL
            if (option.getAttribute('data-value') === selectedValue) {
                option.classList.add('selected', 'focus'); // Dodajemy klasy selected i focus
                currentText = option.innerText; // Zmieniamy tekst na wybrany
            } else {
                option.classList.remove('selected', 'focus'); // Usuwamy klasy z innych elementów
            }
        });
    }

    // Zmiana tekstu w <span class="current">
    const currentSpan = niceSelect ? niceSelect.querySelector('span.current') : null;
    if (currentSpan) {
        currentSpan.textContent = currentText;
    }
};


// Funkcja inicjująca NiceSelect i dodająca klasę "selected" dla elementów na podstawie parametrów URL
const initAndSetSelectedForAllFields = (urlParams, data, selectElements) => {
    const fields = [
        {element: selectElements.tireWidth, data: data.tireWidth, param: urlParams.rozmiar1}, // Szerokość opony
        {element: selectElements.tireProfile, data: data.tireProfile, param: urlParams.rozmiar2}, // Profil opony
        {element: selectElements.rimDiameter, data: data.rimDiameter, param: urlParams.rozmiar3}, // Średnica felgi
        {element: selectElements.loadIndex, data: data.tireWeight, param: urlParams.li, description: true}, // Indeks nośności
        {element: selectElements.speedIndex, data: data.tireSpeed, param: urlParams.si, description: true}, // Indeks prędkości
        {element: selectElements.tireYear, data: data.tireYear, param: urlParams.dot}, // Rok produkcji opony (DOT)
        {element: selectElements.tireClass, data: data.tireClass, param: urlParams.klasa}, // Klasa opony
    ];

    fields.forEach(field => {
        if (field.element) {
            if (field.data) {
                updateSelectOptions(field.element, field.data, field.param, field.description); // Aktualizuj opcje selecta
            }
            initNiceSelectForElements([field.element]); // Inicjuj NiceSelect
            setSelectedOptionInNiceSelect(field.element, field.param); // Ustaw wybraną opcję
        }
    });

    // Inicjalizacja selecta producentów opon z opcjami grupowymi (optgroup)
    if (selectElements.tireProducer && data.producerList) {
        const groupedProducers = groupProducersByClass(data.producerList);
        for (const [groupLabel, producers] of Object.entries(groupedProducers)) {
            const optgroup = document.createElement('optgroup');
            optgroup.label = groupLabel; // Ustaw nazwę grupy
            producers.forEach(producer => {
                const optionElement = document.createElement('option');
                optionElement.value = producer.id;
                optionElement.textContent = producer.value;

                if (producer.id === urlParams.marka) {
                    optionElement.selected = true; // Zaznacz opcję, jeśli pasuje do parametru `marka`
                }

                optgroup.appendChild(optionElement);
            });
            selectElements.tireProducer.appendChild(optgroup);
        }
        initNiceSelectForElements([selectElements.tireProducer]); // Inicjuj NiceSelect dla producentów
        setSelectedOptionInNiceSelect(selectElements.tireProducer, urlParams.marka); // Ustaw wybraną opcję producenta
    }
};

// Funkcja ładowania danych (opon i felg) z plików JSON
const loadTireData = async () => {
    try {
        const tireResponse = await fetch('https://so1.tyresoft.pl/tires.json');
        const tireData = await tireResponse.json();

        const rimResponse = await fetch('https://so1.tyresoft.pl/rims.json');
        const rimData = await rimResponse.json();

        // Pobierz parametry z URL
        const urlParams = getURLParams();

        // Elementy selectów
        const selectElements = {
            tireWidth: document.getElementById('tireWidth'),
            tireProfile: document.getElementById('tireProfile'),
            rimDiameter: document.getElementById('rimDiameter'),
            tireSeason: document.getElementById('tireSeason'),
            tireProducer: document.getElementById('tireProducer'),
            tireClass: document.getElementById('tireClass'),
            loadIndex: document.getElementById('loadIndex'),
            speedIndex: document.getElementById('speedIndex'),
            tireYear: document.getElementById('tireYear'), // Rok produkcji (DOT)
            sortProducts: document.getElementById('sortProducts'),
            rozmiarFelgi: document.getElementById('rozmiarFelgi'),
            srednicaFelgi: document.getElementById('srednicaFelgi'),
            iloscSrub: document.getElementById('iloscSrub'),
            rozstawFelgi: document.getElementById('rozstawFelgi'),
            etFelgi: document.getElementById('etFelgi'),
            mlFelgi: document.getElementById('mlFelgi'),
        };

        // Inicjalizacja selectów dla danych opon
        initAndSetSelectedForAllFields(urlParams, tireData, selectElements);

        // Inicjalizacja selectów dla danych felg
        initAndSetSelectedForRimFields(urlParams, rimData, selectElements);

    } catch (error) {
        console.error('Błąd podczas ładowania danych z JSON:', error);
    }
};

// Funkcja inicjująca pola dla felg z danych JSON
const initAndSetSelectedForRimFields = (urlParams, rimData, selectElements) => {
    const fields = [
        {element: selectElements.rozmiarFelgi, data: rimData.rimSize, param: urlParams.rozmiarFelgi}, // Rozmiar felgi
        {element: selectElements.srednicaFelgi, data: rimData.rimDiameter, param: urlParams.srednicaFelgi}, // Średnica felgi
        {element: selectElements.iloscSrub, data: rimData.rimSpacing1, param: urlParams.iloscSrub}, // Ilość śrub
        {element: selectElements.rozstawFelgi, data: rimData.rimSpacing2, param: urlParams.rozstawFelgi}, // Rozstaw śrub
        {element: selectElements.etFelgi, data: rimData.et, param: urlParams.etFelgi}, // Wartość ET
        {element: selectElements.mlFelgi, data: rimData.rimType, param: urlParams.mlFelgi}, // Typ felgi
    ];

    fields.forEach(field => {
        if (field.element) {
            if (field.data) {
                updateSelectOptions(field.element, field.data, field.param); // Aktualizacja opcji selecta
            }
            initNiceSelectForElements([field.element]); // Inicjalizacja NiceSelect
            setSelectedOptionInNiceSelect(field.element, field.param); // Ustawienie wybranej opcji
        }
    });
};

// Grupowanie producentów według klasy
const groupProducersByClass = (producerList) => {
    const classes = {0: 'Ekonomiczna', 1: 'Średnia', 2: 'Premium'};
    return producerList.reduce((acc, producer) => {
        const groupLabel = classes[producer.class];
        acc[groupLabel] = acc[groupLabel] || [];
        acc[groupLabel].push(producer);
        return acc;
    }, {});
};

// Inicjalizacja po załadowaniu DOM
document.addEventListener('DOMContentLoaded', () => {
    loadTireData(); // Załaduj dane do wszystkich selectów
});

// Inicjalizacja przełączników checkbox/radio
const initCheckboxRadioToggle = () => {
    const groupItems = document.querySelectorAll('.group__item');

    groupItems.forEach(item => {
        const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
        if (!input) return;

        // Obsługa kliknięcia na element `group__item`
        item.addEventListener('click', () => {
            input.checked = input.type === 'checkbox' ? !input.checked : true; // Zmieniaj stan zaznaczenia
            updateUI(input); // Zaktualizuj interfejs
        });

        // Zatrzymaj propagację kliknięć na inputach, aby nie zakłócały działania `group__item`
        input.addEventListener('click', e => e.stopPropagation());
        input.addEventListener('change', () => updateUI(input)); // Zaktualizuj interfejs przy zmianie stanu
    });

    // Funkcja aktualizacji interfejsu w zależności od stanu checkboxa/radio
    const updateUI = (input) => {
        const item = input.closest('.group__item');
        item.classList.toggle('is-active', input.checked);

        // Jeśli input to radio, zaktualizuj inne elementy tego samego typu
        if (input.type === 'radio') {
            document.querySelectorAll(`input[name="${input.name}"]`).forEach(radio => {
                radio.closest('.group__item').classList.toggle('is-active', radio.checked);
            });
        }
    };
};

// Inicjalizacja przycisku do toggle dla filtrów
const initFiltersToggle = () => {
    const buttonHide = document.getElementById('showFilters');
    const hiddenElements = document.querySelectorAll('.hiddenOnMobile');

    buttonHide.addEventListener('click', () => {
        hiddenElements.forEach(element => element.classList.toggle('visible')); // Toggle widoczność elementów
        buttonHide.textContent = buttonHide.textContent === 'Wyszukiwanie zaawansowane'
            ? 'Wyszukiwanie proste'
            : 'Wyszukiwanie zaawansowane'; // Zmieniaj tekst przycisku
    });
};

// Inicjalizacja collapsingu dla dostawców
const initVendorCollapse = () => {
    const titles = document.querySelectorAll('.vendor__title');

    titles.forEach(title => {
        title.addEventListener('click', () => {
            const list = title.nextElementSibling; // Lista dostawców
            const span = title.querySelector('span');

            // Ukryj inne listy dostawców, a tę klikniętą pokaż
            document.querySelectorAll('.vendor__list').forEach(otherList => {
                if (otherList !== list) {
                    otherList.classList.add('hidden');
                    otherList.previousElementSibling.querySelector('span').textContent = '+';
                }
            });

            list.classList.toggle('hidden'); // Toggle widoczność aktualnej listy
            span.textContent = list.classList.contains('hidden') ? '+' : '-'; // Zmieniaj symbol plus/minus
        });
    });
};
